<div class="item-form-container">
  <form [formGroup]="itemForm" class="item-form">
    <!-- Compact Header -->
    <p class="TXT_TITLE w-30">
      ::
      {{
        isEditMode
          ? constants.editItem
          : isViewMode
          ? constants.viewItem
          : constants.addNewItem
      }}::
    </p>

    <!-- Item Details in Compact Grid -->
    <div
      formGroupName="itemTempDto"
      class="item-details"
      style="padding: 10px 0px"
    >
      <!-- Row 1: Item No & Manufacturers -->
      <div class="form-row">
        <div class="form-field">
          <label>Item No.:</label>
          <span class="readonly-value">{{
            itemForm.get("itemTempDto.itemNoTemp")?.value || itemNoTemp
          }}</span>
          <input type="hidden" formControlName="itemNoTemp" />
        </div>
        <div class="form-field">
          <label>Manufacturers:</label>
          <input
            nz-input
            formControlName="itemManufacturer"
            [readonly]="isViewMode"
            placeholder="Enter manufacturer"
          />
        </div>
      </div>

      <!-- Row 2: Description (Full Width) -->
      <div class="form-row full-width">
        <div class="form-field">
          <label
            ><span class="required">*</span>Description:
            <small
              >Include: Product Name, Serial No., Part No., Model, Product
              Desc., Etc.</small
            ></label
          >
          <textarea
            nz-input
            formControlName="itemDesc"
            class="comment-input"
            rows="4"
            [readonly]="isViewMode"
            placeholder="Enter detailed item description"
          ></textarea>
        </div>
      </div>

      <!-- Row 3: Quantity, UOM, Priority -->
      <div class="form-row">
        <div class="form-field">
          <label><span class="required">*</span>Quantity:</label>
          <input
            nz-input
            formControlName="itemQuantity"
            [readonly]="isViewMode"
            placeholder="Enter quantity"
          />
        </div>
        <div class="form-field">
          <label><span class="required">*</span>UOM:</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            formControlName="itemUom"
            [nzDisabled]="isViewMode"
            nzPlaceHolder="Select UOM"
          >
            <nz-option
              *ngFor="let uom of uoms"
              [nzValue]="uom.code"
              [nzLabel]="uom.description"
            ></nz-option>
          </nz-select>
        </div>
        <div class="form-field">
          <label>Priority:</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            formControlName="itemPriority"
            [nzDisabled]="isViewMode"
            nzPlaceHolder="Select Priority"
          >
            <nz-option
              *ngFor="let pri of priority"
              [nzValue]="pri.priorityName"
              [nzLabel]="pri.priorityNameWithValue"
            ></nz-option>
          </nz-select>
        </div>
      </div>

      <!-- Row 4: JDE Item#, QA Code, Suggested Supplier -->
      <div class="form-row">
        <div class="form-field">
          <label>JDE Item#:</label>
          <input
            nz-input
            formControlName="itemJdeItemNo"
            [readonly]="isViewMode"
            placeholder="Enter JDE Item Number"
          />
        </div>
        <div class="form-field">
          <label>QA Code:</label>
          <div class="input-with-action">
            <input
              nz-input
              formControlName="itemQa"
              [value]="selectedQACodes"
              readonly
              placeholder="QA Code"
            />
            <button
              *ngIf="!isViewMode"
              nz-button
              type="button"
              nzType="link"
              nzSize="small"
              (click)="goSelectQA()"
            >
              Select
            </button>
          </div>
        </div>
        <div class="form-field">
          <label>Suggested Supplier:</label>
          <input
            nz-input
            formControlName="itemSuggestSupplier"
            [readonly]="isViewMode"
            placeholder="Enter suggested supplier"
          />
        </div>
      </div>

      <!-- Row 5: Comment (Full Width) -->
      <div class="form-row full-width">
        <div class="form-field">
          <label>Comment:</label>
          <textarea
            nz-input
            formControlName="itemComment"
            rows="4"
            [readonly]="isViewMode"
            placeholder="Enter comments"
            class="comment-input"
          ></textarea>
        </div>
      </div>

      <!-- Row 6: Attachments (Compact) -->
      <div class="form-row attachments-row">
        <div class="form-field" *ngFor="let index of [1, 2, 3]">
          <label>Attachment {{ index }}:</label>
          <div *ngIf="isViewMode" class="attachment-display">
            <span *ngIf="attachments[index - 1]">{{
              attachments[index - 1]?.name
            }}</span>
            <span *ngIf="!attachments[index - 1]" class="no-file">No file</span>
          </div>
          <input
            *ngIf="!isViewMode"
            nz-input
            type="file"
            (change)="onFileChange($event, index)"
            class="file-input"
            [attr.accept]="allowedFileExt.join(',')"
          />
        </div>
      </div>
    </div>

    <!-- Current Attachments (Edit Mode Only) -->
    <div
      *ngIf="isEditMode && attachments.length > 0"
      class="current-attachments"
    >
      <h4>Current Attachments</h4>
      <div class="attachment-list">
        <div *ngFor="let attachment of attachments" class="attachment-item">
          <span class="attachment-name">{{ attachment.name }}</span>
          <div class="attachment-actions">
            <button
              nz-button
              type="button"
              nzType="link"
              nzSize="small"
              (click)="downloadManual(attachment.attachPath)"
            >
              <img
                src="../../../../assets/attach_icon.gif"
                alt="View Item"
                class="attachment-icon"
              />
            </button>
            <button
              nz-button
              type="button"
              nzType="link"
              nzSize="small"
              nzDanger
              (click)="goDelete(attachment.attachId, true)"
            >
              <img
                src="../../../../assets/icons/bin.gif"
                alt="Delete Item"
                class="attachment-icon"
              />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- View Mode Attachments -->
    <div
      *ngIf="isViewMode && attachments.length > 0"
      class="current-attachments"
    >
      <h4>Attachments</h4>
      <div class="attachment-list">
        <div *ngFor="let attachment of attachments" class="attachment-item">
          <span class="attachment-name">{{ attachment.name }}</span>
          <button
            nz-button
            type="button"
            nzType="link"
            nzSize="small"
            (click)="downloadManual(attachment.attachPath)"
          >
            <img
              src="../../../../assets/attach_icon.gif"
              alt="Download Attachment"
              class="attachment-icon"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button
        *ngIf="!isViewMode"
        nz-button
        nzType="primary"
        type="button"
        (click)="onSave()"
      >
        {{ isEditMode ? "SAVE" : "ADD" }}
      </button>
      <button
        *ngIf="!isViewMode"
        nz-button
        nzType="default"
        type="button"
        (click)="goCancel()"
      >
        CANCEL
      </button>
      <button
        *ngIf="isViewMode"
        type="button"
        nz-button
        nzType="default"
        (click)="goBack()"
      >
        BACK
      </button>
    </div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="success-message">
      {{ successMessage }}
    </div>
  </form>
</div>
